export default __webpack_public_path__ + "static/project3-88b060edd99cbcb2e528be2cf2dcb720.jpg";